import { api } from '../services/api'
import { useStoreOwner } from '../store/useStoreOwner'
import { useTermsAgreement } from './useTermsAgreement'

/**
 * EC 出店規約の本文と同意状態 (#1710)。本体は useTermsAgreement (加盟店規約と共通)。
 *
 * 違いは `applicable` — EC の出店者としてリンクされた店舗 (`stores.ecVendorId`) を
 * 持たないオーナーには関係ないので、**取りに行かない** (大半のオーナーは EC 出店者
 * ではない。全員が本文を取ると無駄が大きい)。店舗一覧は /store-auth/me が返す
 * ownedStores にあるので、判定に追加の往復は要らない。
 */
export function useEcVendorTerms() {
  const ownedStores = useStoreOwner((s) => s.ownedStores)
  const applicable = ownedStores.some((s) => typeof s.ecVendorId === 'string' && s.ecVendorId !== '')
  const r = useTermsAgreement('ec_vendor', api.getEcVendorTerms, api.agreeEcVendorTerms, applicable)
  /** EC 出店規約が関係あり、かつ現行版に未同意 (= 同意モーダルを出す状態) */
  const needsAgreement = applicable && !!r.terms && r.terms.needsAgreement
  return { ...r, applicable, needsAgreement }
}
